<template>
  <div>
    <navbar-container :menuType="category" />
    <v-content>
      <page-header></page-header>
      <div class="page-wrapper">
        <v-container fluid fill-height grid-list-md>
          <transition name="fade-transform" mode="out-in">
            <keep-alive include="transactions">
              <router-view> </router-view>
            </keep-alive>
          </transition>
        </v-container>
      </div>
      <v-footer height="auto" class="pa-3 app--footer">
        <span class="caption"
          >DT One &copy; {{ new Date().getFullYear() }} -
          {{ environment }}</span
        >
      </v-footer>
    </v-content>
    <general-snackbar
      :showSnackbar="snackbar.open"
      @setSnackbar="snackbar.open = $event"
      :message="snackbar.text"
      :snackbarColor="snackbar.color"
    >
    </general-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'Layout',
  components: {
    PageHeader,
  },
  props: {
    category: String,
  },
  data: () => ({
    base_domain: `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }${
      window.location.pathname === '/app/index.html' ? '/app/index.html%23' : ''
    }`,
    environment: process.env.VUE_APP_ENV,
  }),
  computed: {
    ...mapState(['snackbar']),
  },
  methods: {
    logout() {
      this.$store.commit('USER_LOGOUT');
      const url = `/jwt/logout_url?redirect_uri=${this.base_domain.replace(
        '%23',
        ''
      )}`;
      this.$http.get(url).then(res => {
        if (res.data.redirect_uri) {
          window.location = res.data.redirect_uri;
        }
      });
    },
  },
};
</script>
<style scoped>
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 41px);
  /* min-height: calc(100vh - 64px - 50px ); No page header included yet*/
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  /*transform: translateX(-30px);*/
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>
